import { FC } from 'react'
import { MainContactFieldProps } from './MainContacts.d'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const MainContactField: FC<MainContactFieldProps> = ({
    field,
    type,
    config,
    formikProps,
    mainContacts,
    setMainContacts,
    originalMainContacts,
    setOriginalMainContacts,
}) => {
    const { values, errors, touched, handleChange, setFieldValue } = formikProps
    const fieldName = type + '-' + field.id

    return (
        <Row>
            <Col xs={11}>
                <Form.Group
                    className="sfy-field mb-3"
                    controlId={`formMainContacts-${type}-${field.id}`}
                >
                    <Form.Control
                        as={config.type === 'textarea' ? 'textarea' : 'input'}
                        name={`${type}-${field.id}`}
                        value={values[fieldName] || ''}
                        onChange={handleChange}
                        placeholder={`Enter ${config.singleLabel}`}
                        className={
                            errors[fieldName] && touched[fieldName]
                                ? 'is-invalid'
                                : ''
                        }
                    />
                    <span className="bottom-border"></span>

                    {errors[fieldName] && touched[fieldName] && (
                        <Form.Text className="invalid-feedback">
                            {errors[fieldName].toString()}
                        </Form.Text>
                    )}
                </Form.Group>
            </Col>
            <Col xs={1} className="p-0">
                <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={(e) => {
                        setFieldValue(fieldName, '')
                        setMainContacts(mainContacts)
                        setOriginalMainContacts((prevState) => {
                            return {
                                ...prevState,
                                [type]: originalMainContacts[type].filter(
                                    (x) => x.id !== field.id
                                ),
                            }
                        })
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} />
                </Button>
            </Col>
        </Row>
    )
}

export default MainContactField
